import { getLocalizedText } from '@softgames/localization';

/**
 * Gets localized String and attempt to localize strings encapsulated in "!{<text>} if they exist".
 * @param input
 */
export function getLocalizedString(input: string): string {
  const matches = input.match(/!{([^}]*)}/g);
  if (matches) {
    let output = input;
    matches.forEach((match) => {
      const substring = match.substring(match.indexOf('{') + 1, match.lastIndexOf('}'));
      output = output.replace(match, getLocalizedText(substring));
    });
    return output;
  }
  return getLocalizedText(input);
}
